module.exports = __webpack_public_path__ + "assets/img/uncheck.638a4743.svg";